/**
 * The window the walk budget is counted over. Fixed rather than sliding: a
 * sliding window would need to retain timestamps, and the only cost of a fixed
 * one is that a burst straddling a boundary can spend two windows' worth of
 * budget in under a second. At these rates that is immaterial.
 */
export const WALK_BUDGET_WINDOW_MS = 1_000;

/**
 * How many denied row-set walks may accumulate before the next one forces a
 * log line of its own.
 *
 * Without this, rate limiting can silence exactly the query it most matters
 * to see: a 100-4999 row `include` query crosses no threshold by itself, so
 * if its walk is denied it produces nothing, and the skip count waits for
 * some unrelated query to cross a threshold and carry it out. Under sustained
 * load from mundane 100+ row queries that wait is unbounded.
 *
 * Flushing on accumulation makes the report self-delivering, at a bounded
 * cost of one extra line per this many skips.
 */
export const SKIP_REPORT_FLUSH_THRESHOLD = 50;

/**
 * Distinct `model.operation` names retained for the skip report. Small on
 * purpose: this answers "what is being silenced", not "everything that was
 * silenced", and it must not grow a set on the denied path.
 */
export const MAX_TRACKED_SKIPPED_QUERIES = 10;
